import { OfflinePaymentService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import dayjs from "dayjs";
export default {
  name: "offline-deposit",
  components: {},
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  props: [],
  data() {
    return {
      orderData: {},
      loading: false
    };
  },
  computed: {},
  mounted() {
    this.getOrderData(this.$route.params.id);
  },
  methods: {
    getOrderData(id) {
      this.loading = true;
      OfflinePaymentService.getPayment(id)
        .then(response => {
          this.orderData = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
